export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑信息',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ riskCheckStatus }) => 'Y' === riskCheckStatus,
  },
  {
    text: that.$l('menu_text_submit') || '提交结果',
    icon: 'el-icon-check',
    menuType: 'submit',
    allow: 'T',
    disabled: ({ riskCheckStatus }) => 'Y' === riskCheckStatus,
  },
]
